BanqueValidator.$inject = ['validator'];

export default function BanqueValidator(validator) {
    const instance = new validator();
    return instance;
}
